import Producer from "../models/ProducerModel";

export const LOAD_PRODUCER = "LOAD_PRODUCER"
export interface LoadProducerAction {
    type: typeof LOAD_PRODUCER
    payload: {
        offlineMode: boolean;
    }
}
export const LOAD_PRODUCER_SUCCESS = "LOAD_PRODUCER_SUCCESS"
export interface LoadProducerSuccessAction {
    type: typeof LOAD_PRODUCER_SUCCESS
    payload: {
        producers: { [key: string]: Producer };
        offlineMode: boolean;
    }
}
export const LOAD_PRODUCER_ERROR = "LOAD_PRODUCER_ERROR"
export interface LoadProducerErrorAction {
    type: typeof LOAD_PRODUCER_ERROR
    payload: string
}
export const ON_SELECTED_PRODUCER = "ON_SELECTED_PRODUCER"
export interface OnSelectedProducerAction {
    type: typeof ON_SELECTED_PRODUCER
    payload: {
        producer: string | null;
        offlineMode: boolean;
    }
}

export const CLEAR_PRODUCER_NOTIFICATION_COUNT = "CLEAR_PRODUCER_NOTIFICATION_COUNT"
export interface ClearProducerNotificationCountAction {
    type: typeof CLEAR_PRODUCER_NOTIFICATION_COUNT
    payload: {
        producerRef: string;
    }
}
export const CLEAR_PRODUCER_STATE = "CLEAR_PRODUCER_STATE"
export interface ClearProducerStateAction {
    type: typeof CLEAR_PRODUCER_STATE
}

export type SharedProducerActionsType = LoadProducerAction
    | LoadProducerSuccessAction
    | LoadProducerErrorAction
    | OnSelectedProducerAction
    | ClearProducerStateAction
    | ClearProducerNotificationCountAction;

export const sharedProducerActions = {

    clearProducerNotificationCount: (producerRef: string): ClearProducerNotificationCountAction => {
        return {
            type: CLEAR_PRODUCER_NOTIFICATION_COUNT,
            payload: {
                producerRef: producerRef,
            },
        }
    },
    clearProducerState: (): ClearProducerStateAction => {
        return {
            type: CLEAR_PRODUCER_STATE,
        }
    },

    onSelectedProducer: (producer: string | null, offlineMode: boolean): OnSelectedProducerAction => {
        return {
            type: ON_SELECTED_PRODUCER,
            payload: {
                producer,
                offlineMode,
            },
        }
    },

    loadProducers: (offlineMode: boolean): LoadProducerAction => {
        return {
            type: LOAD_PRODUCER,
            payload: {
                offlineMode,
            },
        }
    },
    loadProducersSuccess: (producers: { [key: string]: Producer }, offlineMode: boolean): LoadProducerSuccessAction => {
        return {
            type: LOAD_PRODUCER_SUCCESS,
            payload: {
                producers: producers,
                offlineMode: offlineMode,
            },
        }
    },
    loadProducersError: (error: string): LoadProducerErrorAction => {
        return {
            type: LOAD_PRODUCER_ERROR,
            payload: error,
        }
    },

}

export default sharedProducerActions